import axios from 'axios'
export default () => {
  const apiClient = axios.create({
    baseURL: 'https://nucf-spc.herokuapp.com/',
    headers: {
      // Authorization: `Bearer ${localStorage.getItem('access_token') ? localStorage.getItem('access_token') : null}`,
      Accept: 'application/json'
    }
  })
  apiClient.interceptors.response.use((response) => {
    return response
  }, (error) => {
    console.log('error response', error.response.data.message)
    return Promise.reject(error)
  })
  return apiClient
}
